import { Editor, Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';
import { SpellcheckMatch } from '../models/sh-editor-spellcheck.model';

const buildDecorationSet = (editor: Editor, matches: SpellcheckMatch[]): DecorationSet =>
    DecorationSet.create(
        editor.state.doc,
        matches.map((match) =>
            Decoration.inline(match.from, match.to, {
                class: 'sh-editor-misspelled',
                'data-sh-editor-spellcheck': 'true',
                'data-sh-editor-word': match.word,
                'data-sh-editor-from': String(match.from),
                'data-sh-editor-to': String(match.to)
            })
        )
    );

export const SH_EDITOR_SPELLCHECK_PLUGIN_KEY = new PluginKey<DecorationSet>('sh-editor-spellcheck');

export const ShEditorSpellcheckExtension = Extension.create({
    name: 'shEditorSpellcheck',
    addProseMirrorPlugins() {
        return [
            new Plugin({
                key: SH_EDITOR_SPELLCHECK_PLUGIN_KEY,
                state: {
                    init: () => DecorationSet.empty,
                    apply: (transaction, previous) => {
                        const next = transaction.getMeta(SH_EDITOR_SPELLCHECK_PLUGIN_KEY) as DecorationSet | undefined;

                        if (next) {
                            return next;
                        }

                        if (transaction.docChanged) {
                            return previous.map(transaction.mapping, transaction.doc);
                        }

                        return previous;
                    }
                },
                props: {
                    decorations: (state) => SH_EDITOR_SPELLCHECK_PLUGIN_KEY.getState(state)
                }
            })
        ];
    }
});

export const updateSpellcheckDecorations = (editor: Editor, matches: SpellcheckMatch[]): void => {
    const decorations = buildDecorationSet(editor, matches);
    editor.view.dispatch(editor.state.tr.setMeta(SH_EDITOR_SPELLCHECK_PLUGIN_KEY, decorations));
};

export const clearSpellcheckDecorations = (editor: Editor): void => {
    updateSpellcheckDecorations(editor, []);
};
